// @ts-ignore
import { withI18nConsumer } from '@bingads-webui-react/i18n-context';
// @ts-ignore
import { withScope } from '@bingads-webui-react/scope-service';
// @ts-ignore
import { withSettingsConsumer } from '@bingads-webui-react/settings-context';
import {
  withSiteMap,
  processor,
  allSiteMap,
  getRoutePathById,
// @ts-ignore
} from '@bingads-webui-campaign-react/with-site-map';
// @ts-ignore
import { getUNQIndex, UnifiedNotificationQueueShared } from '@bingads-webui-react/unified-notification-queue';
// @ts-ignore
import { withUserConsumer } from '@bingads-webui-react/user-context';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { withStateStore } from '@bingads-webui/with-state-store';
// @ts-ignore
import { withInstrumentation } from '@bingads-webui-react/hoc-with-instrumentation';
import React from 'react';
import _ from 'underscore';

import { NotificationStore, getStoreInstance } from '../notification-store';
import { generateUNQViewAllLink } from '../utils';
import { wrapLogger } from '../utils/logger';
import { PreviewBar } from '../preview-bar';

interface IUNQProps {
  store: NotificationStore;
  i18n: any;
  scope: any;
  classes: any;
  siteMap: any;
  instrumentation: any;
  userContext: {
    CurrentUser: {
      Id: string;
    };
    CurrentCustomer: {
      Id: string;
    };
    CurrentAccount: any;
  };
  settingsContext: {
    Urls: {
      ClientCenterBaseUrl: string;
    };
  };
  ccBaseUrl: string | undefined;
  generateUNQViewAllLink: Function | undefined;
  getPathBySiteMapId: Function | undefined;
  goTargetPage: Function | undefined;
  baseHelpUrl: string | undefined;
  helpParams: {
    project: string | undefined,
    language: string | undefined,
    asRow: number | undefined,
    query: string | undefined,
  } | undefined,
  notificationFilter: Function | undefined,
  showHintMessage: boolean | true,
  permissions: object | undefined,
  setIsActive: ()=> void | undefined,
  forNewGlobalMenu: boolean | undefined,
}

interface Config {
  withContexts: Function;
}

class UnifiedNotificationQueueWrapper extends React.Component<IUNQProps> {
  render() {
    const context: any = _.assign({}, this.props.scope.values, {
      uid: this.props.userContext.CurrentUser.Id,
    });

    const generateUNQViewAllLinkFunc = this.props.generateUNQViewAllLink ||
      generateUNQViewAllLink(this.props.userContext, this.props.scope.values);
    const getPathBySiteMapId = this.props.getPathBySiteMapId ?
      this.props.getPathBySiteMapId :
      (siteMapId: string) => getRoutePathById(this.props.siteMap, siteMapId);
    const goTargetPage = this.props.goTargetPage ?
      this.props.goTargetPage :
      (siteMapId: string, search: string, fallbackHref: string) => this.props.store.context.route.goTargetPage(siteMapId, search, fallbackHref);
    const baseHelpUrl = this.props.baseHelpUrl !== undefined ?
      this.props.baseHelpUrl :
      this.props.store.context.getServerContext().HelpModel.BaseHelpUrl;

    // TODO: update the wrapActionForUINext(action, getPathBySiteMapId, goTargetPage) in /private/client-react/packages/unified-notification-queue/src/utils.js
    return (
      <div className={`${this.props.classes.UNQIndex}`}>
        <div className="unified-notification-queue-container" style={{ alignItems: 'center' }}>
          <div>
            <UnifiedNotificationQueueShared
              context={context}
              shouldShowPreviewBar={this.props.store.state.bannerNotificationList.length === 0}
              PreviewBar={PreviewBar}
              ccBaseUrl={this.props.ccBaseUrl || this.props.settingsContext.Urls.ClientCenterBaseUrl}
              generateViewAllLink={generateUNQViewAllLinkFunc}
              isUINext
              notificationStore={this.props.store}
              i18n={this.props.i18n}
              logger={wrapLogger(this.props.instrumentation)}
              getPathBySiteMapId={getPathBySiteMapId}
              goTargetPage={goTargetPage}
              baseHelpUrl={baseHelpUrl}
              helpParams={this.props.helpParams}
              MTNotificationFilter={this.props.notificationFilter}
              showHintMessage={this.props.showHintMessage}
              permissions={this.props.permissions}
              setIsActive={this.props.setIsActive}
              forNewGlobalMenu={this.props.forNewGlobalMenu}
            />
          </div>
        </div>
      </div>
    );
  }
}

// TODO: Move getUNQIndex to UnifiedNotificationQueue component @xiaohui and @xiliu
const withContexts = (store?: NotificationStore) => _.compose(
  withSettingsConsumer,
  withUserConsumer,
  withScope,
  withI18nConsumer,
  withInstrumentation,
  (Component: any) => withSiteMap(Component, [
    processor.processPermissions,
    processor.processPath,
  ], allSiteMap), // need to use all site map here, since target page might be in other scope
  (Component: any) => withStateStore(Component, store || getStoreInstance()),
  (Component: any) => withDefaultStyles(Component, getUNQIndex)
);

export const getUnifiedNotificationQueue = (store?: NotificationStore, config?: Config) => {
  if (config && config.withContexts && _.isFunction(config.withContexts)) {
    return config.withContexts(store)(UnifiedNotificationQueueWrapper);
  }

  return withContexts(store)(UnifiedNotificationQueueWrapper);
};
